import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IUniteMobileState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const uniteMobileModule: Module<IUniteMobileState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default uniteMobileModule
